import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { LayoutService } from '@app/core/services/layout.service';

@Component({
    selector: 'tt-production-routing-menu',
    templateUrl: './production-routing-menu.component.html',
    styleUrls: ['./production-routing-menu.component.css'],
})
export class ProductionRoutingMenuComponent implements OnInit {
    productionRoutingKeyno;

    public menu?: Menu;

    public grid?: GridOptions;

    public componentsGrid?: GridOptions;

    public productionRoutingButtons: FormButton[] = [{ id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'productionrouting', gotoParms: () => this.menu!.productionrouting_keyno ?? '' }];

    constructor(private stateService: StateService, private datatask: DataTaskService, private modal: ModalService, private layout: LayoutService) {
        this.productionRoutingKeyno = this.stateService.getStateParams()['productionrouting_keyno'];
    }

    private async loadMenu() {
        if (!!this.productionRoutingKeyno) {
            this.menu = (await this.datatask.Post(3650, { productionrouting_keyno: this.productionRoutingKeyno }))[0];
        }
    }

    private readComponentsGrid() {
        if (!this.componentsGrid) {
            this.componentsGrid = new Grid()
                .setRememberId('w_productionroutingwork.grid.components')
                .setLoadDataFunction({ method: 3883, parameters: () => this.menu })
                .setCustomToolbarButtons([
                    {
                        name: 'productionroutingcomp_new',
                        text: 'productionroutingcomp_new',
                        translate: true,
                        icon: 'far fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        func: async () => {
                            if (this.layout.getMediaQueries().tablet.matches === true) {
                                const result = await this.modal.openStateDialog({ state: 'productionroutingcomp', params: `0/${this.menu?.productionrouting_keyno}` });

                                if (!!result) {
                                    this.componentsGrid?.gridfunc?.read();
                                }
                            } else {
                                this.stateService.go('productionroutingcomp', { productionroutingcomp_keyno: '0', productionrouting_keyno: this.menu?.productionrouting_keyno });
                            }
                        },
                    },
                ]);
        } else {
            this.componentsGrid.gridfunc?.read();
        }
    }

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('w_productionroutingwork_grid')
                .setLoadDataFunction({
                    method: 3652,
                    parameters: this.menu,
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([
                    {
                        name: 'productionroutingwork_new',
                        text: 'productionroutingwork_new',
                        func: () =>
                            this.stateService?.go('productionroutingwork', {
                                productionroutingwork_keyno: '0',
                                productionrouting_keyno: this.menu?.productionrouting_keyno,
                            }),
                        icon: 'fas fa-plus',
                        cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
                        translate: true,
                    },
                ]);
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private async init() {
        await this.loadMenu();
        this.loadGrid();
        this.readComponentsGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    productionrouting_keyno: string;
    productionroutinglang_name: string;
    gb_productroutingmenu_main: string;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('productionRoutingMenu', {
//        templateUrl: 'views/components/views/productionRoutingMenu/productionRoutingMenu.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'productionRoutingService', 'ttGridFactory', function ($stateParams, stateService, productionRoutingService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let productionRoutingKeyno = $stateParams.productionrouting_keyno;

//            vm.model = {
//                productionRoutingButtons: [
//                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('productionrouting', { productionrouting_keyno: vm.model.menu.productionrouting_keyno }) }
//                ],
//                menu: {},
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_productionroutingwork_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setCustomToolbarButtons([{
//                name: 'productionroutingwork_new',
//                text: 'productionroutingwork_new',
//                func: () => {
//                    stateService.go('productionroutingwork', {
//                        productionroutingwork_keyno: '0',
//                        productionrouting_keyno: vm.model.menu.productionrouting_keyno
//                    });
//                },
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadMenu() {
//                vm.model.menu = (await productionRoutingService.getEdit({ productionrouting_keyno: productionRoutingKeyno }))[0];

//                loadGrid();
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 3652,
//                    parameters: vm.model.menu
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadMenu();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
